import { useState } from "react";

export default function MessageComposer({
  disabled,
  lockedReason,
  onSend,
  allowLink = false,
  showBetaTag = false,
  defaultBetaTag = false,
}) {
  const [text, setText] = useState("");
  const [file, setFile] = useState(null);
  const [link, setLink] = useState("");
  const [busy, setBusy] = useState(false);
  const [asBeta, setAsBeta] = useState(defaultBetaTag);

  if (disabled) {
    return lockedReason ? <p className="composer-locked">{lockedReason}</p> : null;
  }

  const canSend = Boolean(text.trim() || file || link.trim());

  async function handleSubmit(event) {
    event.preventDefault();
    if (!canSend || busy) return;
    setBusy(true);
    try {
      const linkLine = link.trim() ? `\n\n${link.trim()}` : "";
      await onSend?.(`${text.trim()}${linkLine}`.trim(), file ? [file] : [], asBeta ? "betaFeedback" : null);
      setText("");
      setFile(null);
      setLink("");
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="message-compose" onSubmit={handleSubmit}>
      <div className="message-compose__text">
        <label className="sr-only" htmlFor="message-compose-text">
          Write a note
        </label>
        <textarea
          id="message-compose-text"
          rows={5}
          value={text}
          onChange={(event) => setText(event.target.value)}
          placeholder="Write a calm note…"
          disabled={busy}
        />
      </div>
      {allowLink ? (
        <label className="field">
          <span className="field-label">Attach a link</span>
          <input
            className="field-input"
            type="url"
            value={link}
            onChange={(event) => setLink(event.target.value)}
            placeholder="https://"
            disabled={busy}
          />
        </label>
      ) : null}
      <div className="message-compose__tools">
        <label className="message-compose__attach">
          <span className="sr-only">Attach a file</span>
          <input
            type="file"
            onChange={(event) => setFile(event.target.files?.[0] || null)}
            disabled={busy}
          />
        </label>
        <button type="submit" className="primary-btn" disabled={busy || !canSend}>
          Send
        </button>
        {showBetaTag ? (
          <label className="message-compose__beta">
            <input
              type="checkbox"
              checked={asBeta}
              onChange={(event) => setAsBeta(event.target.checked)}
              disabled={busy}
            />
            Tag as program feedback
          </label>
        ) : null}
        {file ? <p className="message-compose__file muted">{file.name}</p> : null}
      </div>
    </form>
  );
}
